<div class="home-container">
	<span id="login-user" class="seneca-dark-grey">Welcome {{ name }}!</span>
</div>